import { IQuoteTrackingDetail } from "../_common/interface/quoteTrackingDetail/iQuoteTrackingDetail.interface";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "quoteTracking";

export const quoteTracking = {
    post
};

function post(model?: IQuoteTrackingDetail) {
    console.log("qtd service", model);
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}`, requestOptions).then(handleResponse);
}

